/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/Stages/BackgroundData/components/BackgroundFieldLabel.tsx.
 */

import React from "react";
import FormFieldLabel from "../../../../../../components/common/FormFieldLabel";

interface BackgroundFieldLabelProps {
  label: string;
  isMandatory?: boolean;
  infoText?: string | null;
  className?: string;
  ensureQuestionMark?: boolean;
}

/** Background form labels — delegates to shared FormFieldLabel. */
const BackgroundFieldLabel: React.FC<BackgroundFieldLabelProps> = ({
  label,
  isMandatory = false,
  infoText,
  className,
  ensureQuestionMark = false,
}) => (
  <FormFieldLabel
    label={label}
    required={isMandatory}
    infoText={infoText}
    className={className}
    ensureQuestionMark={ensureQuestionMark}
  />
);

/** React component — Background Field Label. */
export default BackgroundFieldLabel;
